import React from 'react';
import Typography from '@material-ui/core/Typography';

const PrizeField = ({ record }) => {
  const { coins, product_name } = record;
  return <Typography>{coins ? `${coins} Coins` : product_name}</Typography>;
};

export default PrizeField;
